import { render } from "./actionmodalwide.vue?vue&type=template&id=116f7deb&scoped=true"
import script from "./actionmodalwide.vue?vue&type=script&lang=js"
export * from "./actionmodalwide.vue?vue&type=script&lang=js"

import "./actionmodalwide.vue?vue&type=style&index=0&id=116f7deb&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116f7deb"]])

export default __exports__